export default __webpack_public_path__ + "static/media/ng.caaf4120.svg";